(function() {
    'use strict';

    angular
        .module('sprintApp')
        .constant('paginationConstants', {
            'itemsPerPage': 50
        });
})();
